import * as React from 'react'

import * as plume from '@ulule/owl-kit-components/next'

export function useDebouncedEffect(
  func: () => void,
  deps: any[],
  options?: {
    immediate?: boolean
    timeout?: number
  },
): void {
  React.useEffect(plume.hooks.useDebounce(func, options?.immediate, options?.timeout), deps)
}
